import { LoadingDots } from '@/features/LoadingScreen/anexes/LoadingDots';
import '@/features/LoadingScreen/styles/index.scss';

const DefaultLoader = ({ isTransitioning }: DefaultLoaderProps) => {
  return (
    <div
      className={`main-loader-wrapper ${
        isTransitioning ? 'transitioning' : ''
      }`}
    >
      <LoadingDots />
    </div>
  );
};

export default DefaultLoader;

export type DefaultLoaderProps = {
  isTransitioning: boolean;
};
